import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';

// Styles
import styles from './FormMessage.module.scss';

// Material UI
import { Button, Snackbar, Slide } from '@material-ui/core';

// Transition
function Transition(props) {
  return <Slide {...props} direction="up" />;
}

export default function FormMessage({
  messageOpen,
  messageState,
  messageText,
  messageActions
}) {
  const [open, setOpen] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    setOpen(messageOpen);
  }, [messageOpen]);

  return (
    <Snackbar
      className={`${styles['form-message']} ` + styles[messageState]}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      open={open}
      message={messageText}
      TransitionComponent={Transition}
      key={Transition.name}
      action={
        <React.Fragment>
          {messageActions &&
            messageActions.map((action, i) => {
              let buttonProps = {};
              if (action.dismiss) {
                buttonProps['onClick'] = handleClose;
                buttonProps['color'] = 'default';
              } else {
                buttonProps['component'] = RouterLink;
                buttonProps['to'] = action.clickUrl;
                buttonProps['color'] = 'primary';
              }
              return (
                <Button
                  className={styles.button}
                  key={i}
                  variant="outlined"
                  size="small"
                  {...buttonProps}>
                  {action.label}
                </Button>
              );
            })}
        </React.Fragment>
      }
      onClose={handleClose}></Snackbar>
  );
}
